import "../css/AppFooter.css";

export default function AppFooter() {
  return (
    <footer className="app-footer">
      <p className="app-footer-title">SiteSync</p>
      <p className="app-footer-line">
        Website designed by Alexander Chiper, Denis Maftei and Bernard Uzo
      </p>
      <p className="app-footer-line">2025-2026 Major Group Project</p>
    </footer>
  );
}
